import type { BingMapCoordinates, GoogleMapCoordinates } from 'ts/types';
import { isGoogleMapCoordinate, isBingMapCoordinate } from './assertions';

export const parseCoordinatesToGoogle = (
  coordinates: BingMapCoordinates | GoogleMapCoordinates,
): GoogleMapCoordinates => {
  if (isGoogleMapCoordinate(coordinates)) {
    return coordinates;
  } else {
    return {
      lat: coordinates?.latitude,
      lng: coordinates?.longitude,
    };
  }
};

export const parseCoordinatesToBing = (
  coordinates: BingMapCoordinates | GoogleMapCoordinates,
): BingMapCoordinates => {
  if (isBingMapCoordinate(coordinates)) {
    return coordinates;
  } else {
    return {
      latitude: coordinates.lat,
      longitude: coordinates.lng,
    };
  }
};

export const parseCountryCodes = (countryCodes: string[]): string =>
  countryCodes.length === 1 ? `country:${countryCodes[0].toLowerCase()}` : '';
